import AppHeader from '../AppHeader'
const utils = require('../../utils')
export default {
  name: 'master-consumable-item-detail',
  async created () {
    await this.getConsumableItem()
    this.isShow = true
  },
  data () {
    return {
      consumableItem: {},
      isShow: false
    }
  },
  computed: {
    imagePath () {
      return this.consumableItem.image_path + '?token=' + window.localStorage.getItem('access_token')
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getConsumableItem () {
      let data = this.$route.params.consumable_item_id
      let res = await this.$store.dispatch('CONSUMABLE_ITEM_SHOW', {id: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.consumableItem = await utils.kebabSnakeConversion(res.data.attributes)
    },
    orderReception () {
      if (this.consumableItem.is_can_order) {
        return '受付中'
      } else {
        return '発注不可'
      }
    },
    content (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    },
    onClickCancel () {
      this.$router.push('/master_consumable_item_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-detail.js